// External Imports
import { useEffect, useRef, useState } from "react";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import { MdClose } from "react-icons/md";
import VehicleSelector from "../vehicles-page/VehicleSelector";
import DetailPair from "../UI/DetailPair";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { requestAdminAPI } from "../../api/posh-api";

/** ========================================================================
 * * AddService Component
 * This component renders a form to add a service.
 * ========================================================================== */

export default function AddService({ open, setOpen, onComplete }) {
  const [loading, setLoading] = useState(false);
  const [vehicle, setVehicle] = useState();
  const mileageRef = useRef();
  /* ====================== GET MILEAGE ====================== */

  /* ======================= FETCH VEHICLE STATS ======================= */
  const fetchVehicleStats = async () => {
    try {
      setLoading(true);
      // Send Request
      const response = await requestAdminAPI("fetch-vehicle-reports", {
        vehicles: [{ vin: vehicle.vin, trackerId: vehicle.trackerId }],
      });
      const report = response[0]?.report;
      if (report) mileageRef.current.value = report.mileage;
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  /* ====================== ADD SERVICE ====================== */
  const submitHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        vehicleId: vehicle.id,
        intervalMiles: document.getElementById("intervalMiles").value,
        description: document.getElementById("description").value,
        currentMileage: document.getElementById("currentMileage").value,
      };
      const dueDate = new Date();
      dueDate.setMonth(
        dueDate.getMonth() +
          parseInt(document.getElementById("intervalMonths").value)
      );
      payload.dueDate = dueDate;
      const response = await requestAdminAPI("add-service", payload);
      setOpen(false);
      onComplete && onComplete();
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vehicle) fetchVehicleStats();
  }, [vehicle])

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal lg:w-[45vw] gap-6">
        <Heading title="Add Service" isBackArrow={false}>
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>
        <div className="info">
          <div className="lg:col-span-2">
            <VehicleSelector selected={vehicle?.id} onSelect={setVehicle} />
          </div>
          <DetailPair
            edit={true}
            label="Interval Miles"
            inputOptions={{
              required: true,
              type: "number",
              id: "intervalMiles",
            }}
          />
          <DetailPair
            edit={true}
            label="Interval Months"
            inputOptions={{
              required: true,
              type: "number",
              id: "intervalMonths",
            }}
          />
          <DetailPair
            edit={true}
            label="Current Mileage"
            inputOptions={{
              required: true,
              type: "number",
              id: "currentMileage",
              ref: mileageRef,
            }}
          />
          <div className="lg:col-span-3">
            <DetailPair
              edit={true}
              label="Description"
              inputOptions={{
                required: true,
                type: "text",
                id: "description",
              }}
            />
          </div>
        </div>
        {loading ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="grid gap-4 text-sm lg:grid-cols-2">
            <div className="btn-secondary" onClick={() => setOpen(false)}>
              Cancel
            </div>
            <div className="btn-primary" onClick={submitHandler}>
              Submit
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
